/* Plan areny — wyłącznie wizualny przewodnik.
   Dane: window.SEKCJE (z produktów Shopify), teksty: window.MAPA_T (z locales).
   Klik w sekcję przewija do jej wiersza na liście biletów (tam jest natywny „Dodaj do koszyka”). */
if (document.getElementById('mapa')) {

const SEKCJE = window.SEKCJE || {};
const T = window.MAPA_T || {available:'Dostępne', sold_out:'Wyprzedane', closed:'Brak sprzedaży', stage:'SCENA'};
const KOLORY = {k1:'#c39a72', k2:'#d3b48c', k3:'#e3cda9', k4:'#efe0c4', wyp:'#e3ded4'};

function odcien(pln){
  if(pln>=1200) return KOLORY.k1;
  if(pln>=800)  return KOLORY.k2;
  if(pln>=560)  return KOLORY.k3;
  return KOLORY.k4;
}
function stan(n){ const p=SEKCJE[n]; if(!p) return 'zamknieta'; return p.dostepny?'dostepna':'wyprzedana'; }

const NS='http://www.w3.org/2000/svg';
const svg=document.getElementById('mapa');
const CX=500, CY=395;
const el=(t,at)=>{const e=document.createElementNS(NS,t);for(const k in at)e.setAttribute(k,at[k]);return e};

const defs=el('defs',{});
defs.innerHTML='<pattern id="wzor-zamkniete" width="9" height="9" patternTransform="rotate(45)" patternUnits="userSpaceOnUse">'
  +'<rect width="9" height="9" fill="#ece7dc"/><line x1="1" y1="0" x2="1" y2="9" stroke="#c2b8a4" stroke-width="2.2"/></pattern>';
svg.appendChild(defs);

function pt(rx,ry,deg){const r=deg*Math.PI/180;return [CX+rx*Math.cos(r), CY+ry*Math.sin(r)]}
function segment(rx1,ry1,rx2,ry2,a1,a2){
  const [x1,y1]=pt(rx1,ry1,a1),[x2,y2]=pt(rx1,ry1,a2),[x3,y3]=pt(rx2,ry2,a2),[x4,y4]=pt(rx2,ry2,a1);
  return `M ${x1} ${y1} A ${rx1} ${ry1} 0 0 1 ${x2} ${y2} L ${x3} ${y3} A ${rx2} ${ry2} 0 0 0 ${x4} ${y4} Z`;
}
const warstwaSek=el('g',{}), warstwaTxt=el('g',{});
svg.appendChild(warstwaSek); svg.appendChild(warstwaTxt);

function dodajSekcje(nazwa, path, lx, ly, fontSize){
  const st=stan(nazwa), p=SEKCJE[nazwa];
  let fill, aria;
  if(st==='dostepna'){ fill=odcien(p.cena); aria=`${nazwa} — ${p.cenaFormat}`; }
  else if(st==='wyprzedana'){ fill=KOLORY.wyp; aria=`${nazwa} — ${T.sold_out}`; }
  else { fill='url(#wzor-zamkniete)'; aria=`${nazwa} — ${T.closed}`; }
  const s=el('path',{d:path,class:'sek '+st,fill:fill,'data-s':nazwa,'aria-label':aria});
  if(st!=='zamknieta'){ s.setAttribute('tabindex','0'); s.setAttribute('role','button'); }
  warstwaSek.appendChild(s);
  const t=el('text',{x:lx,y:ly,class:'et '+(st==='dostepna'?'':st==='wyprzedana'?'wyp':'zamk'),'font-size':fontSize,'data-et':nazwa});
  t.textContent=nazwa; warstwaTxt.appendChild(t);
}

/* pierścień górny G: G19…G37, G1…G18 (zgodnie z ruchem wskazówek od góry) */
(function(){
  const k=[]; for(let i=19;i<=37;i++)k.push('G'+i); for(let i=1;i<=18;i++)k.push('G'+i);
  const n=37, krok=360/n, luz=0.7;
  k.forEach((s,i)=>{
    const a1=-90+i*krok+luz, a2=-90+(i+1)*krok-luz, am=(a1+a2)/2;
    const [lx,ly]=pt(435,342,am);
    dodajSekcje(s, segment(478,378,394,306,a1,a2), lx, ly+5, 15);
  });
})();

/* pierścień dolny: D11…D20, V01…V05, D1…D10 */
(function(){
  const k=[]; for(let i=11;i<=20;i++)k.push('D'+i);
  ['V01','V02','V03','V04','V05'].forEach(v=>k.push(v));
  for(let i=1;i<=10;i++)k.push('D'+i);
  const n=25, krok=360/n, luz=0.8;
  k.forEach((s,i)=>{
    const a1=-90+i*krok+luz, a2=-90+(i+1)*krok-luz, am=(a1+a2)/2;
    const [lx,ly]=pt(340,258,am);
    dodajSekcje(s, segment(376,290,304,228,a1,a2), lx, ly+5, 14);
  });
})();

/* scena */
(function(){
  const g=el('g',{});
  g.appendChild(el('rect',{x:212,y:322,width:64,height:146,fill:'#131118',stroke:'#c39a72','stroke-width':1.5}));
  const t=el('text',{x:244,y:395,class:'et','font-size':14,transform:'rotate(-90 244 395)'});
  t.textContent=T.stage; t.style.fill='#f6f4f0';
  g.appendChild(t); svg.appendChild(g);
})();

/* parter */
(function(){
  ['C01','C02','C03','C04'].forEach((s,i)=>{
    const x=352+i*80;
    dodajSekcje(s, `M ${x} 208 H ${x+74} V 246 H ${x} Z`, x+37, 232, 14);
  });
  ['A8','A7','A6','A5','A3','A2','A1','A0'].forEach((s,i)=>{
    const y=266+i*33.5;
    dodajSekcje(s, `M 296 ${y} H 428 V ${y+29} H 296 Z`, 362, y+20, 15);
  });
  ['B6','B5','B4','B3','B2','B1'].forEach((s,i)=>{
    const y=300+i*38;
    dodajSekcje(s, `M 438 ${y} H 570 V ${y+34} H 438 Z`, 504, y+23, 15);
  });
  ['C8','C7','C6','C5','C2','C0'].forEach((s,i)=>{
    const y=278+i*38;
    dodajSekcje(s, `M 580 ${y} H 700 V ${y+34} H 580 Z`, 640, y+23, 15);
  });
})();

/* legenda (3 stany) */
(function(){
  const L=document.getElementById('legenda'); if(!L) return;
  [[T.available, KOLORY.k2, null],
   [T.sold_out, KOLORY.wyp, null],
   [T.closed, null, 'repeating-linear-gradient(45deg,#ece7dc 0 4px,#c2b8a4 4px 6px)']]
  .forEach(([n,c,grad])=>{
    const s=document.createElement('span');
    s.innerHTML=`<i style="background:${grad||c}"></i>${n}`;
    L.appendChild(s);
  });
})();

/* klik → przewiń do wiersza biletu */
function doWiersza(nazwa){
  if(stan(nazwa)==='zamknieta') return;
  const w=document.getElementById('bilet-'+nazwa);
  if(!w) return;
  w.scrollIntoView({behavior:'smooth', block:'center'});
  w.classList.remove('blysk'); void w.offsetWidth; w.classList.add('blysk');
}
svg.addEventListener('click',e=>{const s=e.target.closest('.sek');if(s)doWiersza(s.dataset.s)});
svg.addEventListener('keydown',e=>{if((e.key==='Enter'||e.key===' ')&&e.target.classList.contains('sek')){e.preventDefault();doWiersza(e.target.dataset.s)}});

}
